import debounce from 'lodash.debounce'
import gsap from 'gsap'

const configureTiles = (e) => {

	const tileBlock = Array.from(document.querySelectorAll('.rollover-tile-grid'))

	tileBlock.forEach(block => {
		const tileSet = Array.from(block.querySelectorAll('.tile-container'))

		let tallestHeight = 0
		
		tileSet.forEach(tile => {
			tile.style.removeProperty('height')	
		})
		
		tileSet.forEach(tile => {
			if(tallestHeight < tile.offsetHeight) tallestHeight = tile.offsetHeight
		})

		if (window.innerWidth > 1023) {
			tileSet.forEach(tile => {
				tile.style.height = tallestHeight + 'px'
			})
		}
		

		let tallestGroupHeight = 0
		const tileHeightElement = block.querySelector('.tile-container')
		if (!tileHeightElement) return; // Exit if required element doesn't exist
		
		const tileHeight = tileHeightElement.offsetHeight
		tileSet.forEach(tile => {
			const iconContainer = tile.querySelector('.icon-container')
			const tileHeader = tile.querySelector('.tile-header')
			
			if (!iconContainer || !tileHeader) return; // Skip if required elements don't exist
			
			const iconContainerHeight = iconContainer.offsetHeight
			const textHeight = tileHeader.offsetHeight
			const contentHeight = iconContainerHeight + textHeight;
			if (tallestGroupHeight < contentHeight) tallestGroupHeight = contentHeight;
		})


		tileSet.forEach(tile => {
			const iconContainer = tile.querySelector('.icon-header-container')
			if (iconContainer) {
				gsap.set(iconContainer, {y:(tileHeight - tallestGroupHeight - 70) / 2 })
			}
		})

	})

};

const debouncedResize = debounce(configureTiles)

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	configureTiles();
} else {
	document.addEventListener("DOMContentLoaded", configureTiles);
	window.addEventListener("resize", debounce(configureTiles));
}